import { useQuery } from "@tanstack/react-query";
import { fetchWalletBalances } from "../lib/api";
import { queryKeys } from "../lib/queryKeys";

export function useWalletBalances() {
	return useQuery({
		queryKey: queryKeys.walletBalances,
		queryFn: fetchWalletBalances,
		// Balances are slow-changing in normal sessions; refetch only on
		// explicit invalidation (from the cart Execute path).
		refetchOnWindowFocus: false,
		staleTime: 60_000,
	});
}
